import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useModalData } from "../../../../components/Modal/useModalData";
import Form, { FORM_HORIZONTAL_LAYOUT } from "../../../../components/Form";
import useFormSubmit from "../../../../components/Form/useFormSubmit";
import { closeModalAction } from "../../../../components/Modal/reducer";
import Button from "../../../../components/Button";
import { renderDynamicallyFields } from "../../../../components/Form/methods";
import { updateTemplatesState } from "../reducer";
import { usePermission } from "../../../../components/_auth/permissions/usePermission";
import { PERMISSION_MANAGE_DOM_HEADERS_FOOTERS_COVERS } from "../../../../components/_auth/permissions/permissions";
import { buildTemplateFormFields, MODAL_TEMPLATE_FORM } from "./templateFormFields";

export { MODAL_TEMPLATE_FORM } from "./templateFormFields";

const TemplateForm = ({ modalName }) => {
  const permissions = usePermission();
  const canManageHeadersFooters = permissions.canDo(PERMISSION_MANAGE_DOM_HEADERS_FOOTERS_COVERS);
  const data = useModalData(modalName || MODAL_TEMPLATE_FORM);
  const isEdit = !!data?.historyId;
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { loading, submit, generalError } = useFormSubmit({
    form,
    route: isEdit ? `dom/template-histories/${data.historyId}` : "dom/templates",
    method: isEdit ? "put" : "post",
    onSuccess: () => {
      if (data?.onSuccess) {
        data.onSuccess();
      } else {
        dispatch(updateTemplatesState({ reload: true, keepFilters: isEdit }));
        dispatch(closeModalAction({ name: MODAL_TEMPLATE_FORM }));
      }
    }
  });

  return (
    <Form
      onSubmit={submit}
      form={form}
      errors={generalError}
      loading={loading}
      initialValues={{
        ...(isEdit
          ? {
              ...data,
              header_id: data?.validVersionHistory?.header_id,
              footer_id: data?.validVersionHistory?.footer_id,
              cover_id: data?.validVersionHistory?.cover_id
            }
          : { ...data }),
        active: isEdit ? data?.active : true
      }}
      layout={FORM_HORIZONTAL_LAYOUT}
      header={
        <>
          <div className="h3">{t(isEdit ? "dom.templates.edit_template" : "dom.templates.new_template")}</div>
          <div className="mb-30 mt-10 h6 font-weight-300 text-muted">{t("container.general_words.form_subtitle")}</div>
        </>
      }
    >
      {renderDynamicallyFields(buildTemplateFormFields({ data, isEdit, form, t, dispatch, canManageHeadersFooters }))}
      <div className="flex mt-25 flex-justify-end">
        <Button
          className="min-w-150"
          type="primary"
          htmlType="submit"
          disabled={loading}
          loading={loading}
          icon={<i className="ti-check" />}
        >
          {t("container.general_words.save")}
        </Button>
      </div>
    </Form>
  );
};

export default TemplateForm;
